<template>
  <div class="h-100">
    <div class="header"></div>

    <slot />

    <footer class="footer">
      <main-footer />
    </footer>

  </div>
</template>

<script>
import MainFooter from "@/components/layout/MainFooter/MainFooter.vue";
export default {
  name: "default",
  components: {
    MainFooter
  },
  data() {
    return {};
  }
};
</script>

<style>
.header {
  height: 20%;
}

.footer {
    position: absolute;
    bottom: 0;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Default.vue